import logo from 'assets/images/logo.svg';

// ==============================|| LOGO SVG ||============================== //

export default function LogoMain() {
  return <img src={logo} alt="logo" />;
}
